export const AUTH_SERVICE_TYPE = "saml";
export const SSO_PATH_PREFIX = "/sso";
export const SSO_SAML_PATH = `${SSO_PATH_PREFIX}/saml`;
export const SSO_SAML_ACS_PATH = `${SSO_PATH_PREFIX}/saml/acs`;
export const SSO_SAML_LOGOUT_PATH = `${SSO_PATH_PREFIX}/saml/logout`;
